import { PenLine } from 'lucide-react';
import { LandingHeader } from '@/components/LandingHeader';
import { LandingFooter } from '@/components/LandingFooter';
import { useTranslation } from '@/hooks/useTranslation';
import { Reveal } from '@/components/landing/motion-primitives';
import { CtaSection, PageHero } from '@/components/landing/page-kit';

export default function BlogPage() {
  const { language, t } = useTranslation();
  const fr = language === 'fr';

  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingHeader />

      <main>
        <PageHero
          eyebrow={fr ? 'Journal' : 'Journal'}
          title={fr ? 'Le blog de' : 'The'}
          highlight="clevia"
          subtitle={
            fr
              ? 'Conseils, astuces et articles pour maîtriser votre finance personnelle.'
              : 'Tips, tricks and articles to master your personal finances.'
          }
        />

        {/* ── État vide ──────────────────────────────────────────── */}
        <section className="border-b border-border px-6 pb-24 lg:pb-32">
          <div className="mx-auto max-w-3xl">
            <Reveal>
              <div className="rounded-xl border border-dashed border-border bg-muted/20 px-8 py-16 text-center">
                <PenLine className="mx-auto h-5 w-5 text-muted-foreground" aria-hidden="true" />
                <p className="mx-auto mt-5 max-w-md text-pretty leading-relaxed text-muted-foreground">
                  {t('blog.empty')}
                </p>
              </div>
            </Reveal>
          </div>
        </section>

        <CtaSection
          title={
            fr
              ? "En attendant, prenez de l'avance sur votre budget"
              : 'In the meantime, get ahead of your budget'
          }
          subtitle={
            fr
              ? 'Créez votre compte et suivez vos comptes, vos dépenses et vos objectifs au même endroit.'
              : 'Create your account and track your accounts, spending and goals in one place.'
          }
          action={{
            label: fr ? 'Commencer gratuitement' : 'Get started free',
            to: '/register',
          }}
        />
      </main>

      <LandingFooter />
    </div>
  );
}
